export { ObjectiveLevelValues, isValidObjectiveLevel, levelButtonClass }

const ObjectiveLevelValues = {
  QUARTER_1ST: '1st',
  QUARTER_2ND: '2nd',
  QUARTER_3RD: '3rd',
  QUARTER_4TH: '4th'
}

const validObjectiveLevels = [
  ObjectiveLevelValues.QUARTER_1ST,
  ObjectiveLevelValues.QUARTER_2ND,
  ObjectiveLevelValues.QUARTER_3RD,
  ObjectiveLevelValues.QUARTER_4TH
]
function isValidObjectiveLevel(level) {
  return validObjectiveLevels.includes(level)
}

function levelButtonClass(level) {
  if (level === ObjectiveLevelValues.QUARTER_1ST) {
    return 'btn-teal'
  }
  if (level === ObjectiveLevelValues.QUARTER_2ND) {
    return 'btn-blue'
  }
  if (level === ObjectiveLevelValues.QUARTER_3RD) {
    return 'btn-purple'
  }
  return ''
}
